type LicenseType = {
    code: string;
    erpCode: string;
    description: string;
    isVisible: boolean;
}

export const LicenseTypes: LicenseType[] = [
    { code: "11", erpCode: "01003", description: "1종 대형", isVisible: true},
    { code: "12", erpCode: "01001", description: "1종 보통", isVisible: true },
    { code: "32", erpCode: "02001", description: "2종 보통", isVisible: true },

    { code: "13", erpCode: "01002", description: "1종 소형", isVisible: false },
    { code: "33", erpCode: "02002", description: "2종 소형", isVisible: false },
    { code: "38", erpCode: "02003", description: "2종 원동기", isVisible: false },

    { code: "14", erpCode: "01004", description: "특수(대형견인)", isVisible: true },
    { code: "15", erpCode: "01005", description: "특수(구난)", isVisible: true },
    { code: "16", erpCode: "01006", description: "특수(소형견인)", isVisible: true },
];